import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('flexioss_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => { localStorage.setItem('flexioss_cookie_consent', 'accepted'); setShow(false); };
  const decline = () => { localStorage.setItem('flexioss_cookie_consent', 'declined'); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          data-testid="cookie-consent"
          className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6 pointer-events-none"
        >
          <div className="max-w-3xl mx-auto bg-slate-800/95 backdrop-blur-xl border border-slate-700 rounded-xl p-4 sm:p-5 shadow-2xl shadow-black/40 flex flex-col sm:flex-row items-start sm:items-center gap-4 pointer-events-auto">
            <Cookie className="w-8 h-8 text-blue-400 flex-shrink-0 hidden sm:block" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-slate-300 leading-relaxed">
                This website uses essential cookies to ensure proper functionality. We also use analytics cookies to understand how you interact with our content. By clicking "Accept," you consent to our use of cookies.{' '}
                <Link to="/cookie-policy" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">Read our Cookie Policy</Link>
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
              <button onClick={decline} data-testid="cookie-decline" className="flex-1 sm:flex-none px-4 py-2 text-sm font-semibold text-slate-400 hover:text-white border border-slate-600 rounded-lg hover:border-slate-500 transition-colors">
                Decline
              </button>
              <button onClick={accept} data-testid="cookie-accept" className="flex-1 sm:flex-none px-5 py-2 text-sm font-bold text-white bg-[#E87A20] hover:bg-[#d06d18] rounded-lg shadow-lg transition-colors">
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
